import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-MyConsulationRequest-form',
  templateUrl: './MyConsulationRequest-form.component.html',
  styleUrls: ['./MyConsulationRequest-form.component.css']
})
export class MyConsulationRequestFormComponent implements OnInit {
  title="My Consultation Request";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/tasks/MyConsulationRequest/MyConsulationRequest-form/MyConsulationRequest-form.component.ts